import heroImg from "../assets/Frame 375.png"; // replace with your full hero image
import googleImg from "../assets/image 1.png";
import appStoreImg from "../assets/image 2.png";

function Hero() {
  return (
    <section className="hero-section py-lg-5 px-lg-5 bg-light">
      <div className="containe hero-inner py-lg-0 py-5 px-3 px-lg-5 ">
        <div className="row justify-between  align-items-center">
          {/* Left side: text */}
          <div className="col-lg-5 text-center text-lg-start">
            <h1 className="fw-bold display-5 mb-3">
              Speak Up. Stay Safe. <br />
              <span className="text-success">Get Rewarded.</span>
            </h1>

            <div className="d-flex flex-wrap gap-2 justify-content-center justify-content-lg-start mb-4">
              <span className="badge rounded-pill bg-success-subtle text-success px-3 py-2">
                Report Civic Incidents
              </span>
              <span className="badge rounded-pill bg-danger-subtle text-danger px-3 py-2">
                Alert Emergencies
              </span>
              <span className="badge rounded-pill bg-primary-subtle text-primary px-3 py-2">
                Earn for Making a Difference
              </span>
            </div>

            <p className="text-muted mb-4">
              Report accidents, environmental hazards, infrastructure issues, or
              request help in an emergency — all from one powerful app.
              <br />
              Be part of the change, and get rewarded for every verified report.
            </p>

            <div className="d-flex gap-2 justify-content-center justify-content-lg-start">
              <a href="https://play.google.com/">
                <img src={googleImg} alt="Google Play" height="45" />
              </a>
              <a href="https://play.google.com/">
                <img src={appStoreImg} alt="App Store" height="45" />
              </a>
            </div>
          </div>

          {/* Right side: image */}
          <div className="col-lg-7 text-center mt-4 mt-lg-0">
            <img
              src={heroImg}
              alt="CivicX App Preview"
              className="img-fluid"
              // style={{ maxHeight: "520px" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
